import { ChevronLeft, ChevronRight, Phone, TrendingDown, TrendingUp } from "lucide-react";
import { Image } from "@openai/apps-sdk-ui/components/Image";
import { openExternal, formatNumber } from "../../utils";
import emlakjetLogo from "../../logo.svg";

const EMLAKJET_GREEN = "#16a34a";

/**
 * Hero image section with navigation, price badge, and CTA buttons
 */
export function DetailHeroImage({
  images,
  selectedImageIndex,
  setSelectedImageIndex,
  priceLabel,
  squareMeterPrice,
  fromOwner,
  priceChangeRate,
  href,
  phone,
  telHref,
  isDark,
}) {
  const selectedImage = images[selectedImageIndex] ?? images[0] ?? null;

  return (
    <div className="relative w-full aspect-[4/3] overflow-hidden flex-shrink-0 group">
      {/* Main Image */}
      {selectedImage ? (
        <Image src={selectedImage} alt="İlan görseli" className="w-full h-full object-cover" />
      ) : (
        <div className={`w-full h-full flex items-center justify-center ${isDark ? "bg-white/5" : "bg-black/5"}`}>
          <span className={`text-xs ${isDark ? "text-white/40" : "text-black/40"}`}>Görsel yok</span>
        </div>
      )}

      {/* Navigation Buttons */}
      {images.length > 1 && (
        <>
          <button
            onClick={() => setSelectedImageIndex((prev) => (prev > 0 ? prev - 1 : images.length - 1))}
            className="absolute left-2 top-1/2 -translate-y-1/2 w-10 h-10 rounded-full bg-black/40 backdrop-blur-sm text-white flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity hover:bg-black/60 z-20"
            aria-label="Önceki görsel"
          >
            <ChevronLeft className="h-6 w-6" strokeWidth={2} />
          </button>
          <button
            onClick={() => setSelectedImageIndex((prev) => (prev < images.length - 1 ? prev + 1 : 0))}
            className="absolute right-2 top-1/2 -translate-y-1/2 w-10 h-10 rounded-full bg-black/40 backdrop-blur-sm text-white flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity hover:bg-black/60 z-20"
            aria-label="Sonraki görsel"
          >
            <ChevronRight className="h-6 w-6" strokeWidth={2} />
          </button>
        </>
      )}

      {/* Price Badge - Bottom Left */}
      <div className="absolute bottom-3 left-3 flex flex-col gap-1">
        <div
          className="px-3 py-1.5 rounded-lg text-white font-bold text-lg shadow-lg"
          style={{ backgroundColor: EMLAKJET_GREEN }}
        >
          {priceLabel ?? "—"}
        </div>
        {squareMeterPrice && (
          <div className="px-2 py-1 rounded-md bg-black/60 backdrop-blur-sm text-white text-xs font-medium">
            ₺{formatNumber(squareMeterPrice)}/m²
          </div>
        )}
      </div>

      {/* Right Side Badges - Bottom Right */}
      <div className="absolute bottom-3 right-3 flex flex-col gap-1.5 items-end">
        {fromOwner && (
          <div className="px-2.5 py-1 rounded-full bg-amber-500 text-white text-xs font-medium shadow-lg">
            Sahibinden
          </div>
        )}
        {priceChangeRate !== null && priceChangeRate !== 0 && (
          <div className={`flex items-center gap-1 px-2 py-1 rounded-full text-xs font-medium shadow-lg ${priceChangeRate > 0 ? "bg-red-500/90 text-white" : "bg-green-500/90 text-white"}`}>
            {priceChangeRate > 0 ? <TrendingUp className="h-3 w-3" /> : <TrendingDown className="h-3 w-3" />}
            %{Math.abs(priceChangeRate).toFixed(0)} {priceChangeRate > 0 ? "artış" : "düşüş"}
          </div>
        )}

        {/* CTA Buttons */}
        <div className="flex items-center gap-1.5">
          {href && (
            <button
              onClick={() => openExternal(href)}
              className="flex items-center px-2.5 py-1.5 rounded-lg bg-white/95 backdrop-blur-sm shadow-lg"
            >
              <img src={emlakjetLogo} alt="Emlakjet'te aç" className="h-5 w-auto" />
            </button>
          )}
          {phone && (
            <button
              onClick={() => openExternal(telHref)}
              className="flex items-center justify-center w-9 h-9 rounded-lg shadow-lg"
              style={{ backgroundColor: EMLAKJET_GREEN }}
            >
              <Phone className="h-4 w-4 text-white" strokeWidth={2} />
            </button>
          )}
        </div>
      </div>
    </div>
  );
}

export default DetailHeroImage;
